module.exports = __webpack_public_path__ + "img/cash.f88c0e67.svg";